export default "__VITE_ASSET__CFbRSoKJ__"